import nodule11 from "./nodule1-1";
import nodule12 from "./nodule1-2";
import nodule13 from "./nodule1-3";

export default [
  nodule11,
  nodule12,
  nodule13
];
